import styled from "@emotion/styled";
import {Button, Checkbox, Switch, Text} from "@blueprintjs/core";
import {COLORS} from "../../../../../constants/constants";

export const ETANotificationContainer = styled.div`
  width: calc(100vw - 220px);
  height: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
`;

export const ETANotificationFormContainer = styled.div`
  position: relative;
  max-width: 100%;
  height: 100%;
  overflow: auto;
  padding: 24px 24px 0 24px;

  .premium-disabled-block {
    *:not(.premium-badge) {
      color: rgba(95, 107, 124, 0.6) !important;
    }

    .input-background {
      background: #f3f4f686 !important;
    }

    input {
      cursor: not-allowed;
    }
  }
`;

export const ETANotificationCreatePage = styled.div`
  width: 100%;
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  align-items: center;
`;

export const FormColumnBlock = styled.div<{withDivider?: boolean; gap?: string; padding?: string}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.gap ? props.gap : "16px")};
  padding: ${(props) => (props.padding ? props.padding : "24px 0")};
  border-bottom: ${(props) => (props.withDivider ? `1px solid ${COLORS.COLOR_BORDER_DIVIDER}` : "none")};
`;

export const FormRowBlock = styled.div<{gap?: string}>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: ${(props) => (props.gap ? props.gap : "16px")};
  align-items: center;
`;

export const HeaderText = styled(Text)<{
  fontSize?: string;
}>`
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "22px")};
  line-height: 20px;
  letter-spacing: 0;
  text-transform: capitalize;
  color: ${COLORS.TEXT_BLACK};

  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

export const SubHeaderText = styled(Text)<{fontSize?: string}>`
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "14px")};
  line-height: 20px;
  letter-spacing: 0;
  color: ${COLORS.TEXT_GRAY_MEDIUM};
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const ETAInput = styled.input<{width?: string; padding?: string}>`
  width: ${(props) => (props.width ? props.width : "100%")};
  height: 32px;
  padding: ${(props) => (props.padding ? props.padding : "8px")};
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  border: 1px solid ${COLORS.COLOR_BORDER};
  border-radius: 8px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;

  :disabled {
    background: #fff !important;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: ${COLORS.TEXT_RED};
  font-size: 12px;
  position: absolute;
  bottom: -18px;

  white-space: nowrap;
`;

export const ETASelectButton = styled(Button)<{
  hasValue: boolean;
}>`
  position: relative;
  width: fit-content;
  border: ${(props) =>
    props.hasValue ? `1px solid ${COLORS.BLUE_LIGHT} !important` : `1px solid ${COLORS.COLOR_BORDER}`};
  border-radius: 8px;

  box-shadow: none !important;
  background: ${(props) => (props.hasValue ? `${COLORS.BLUE_VERY_LIGHT} !important` : `${COLORS.WHITE} !important`)};
  padding: 6px 8px;
  font-size: 14px;

  .bp5-button-text {
    display: flex;
    flex-direction: row;
    align-items: end;
    color: ${(props) => (props.hasValue ? `${COLORS.BLUE_DARK} !important` : `${COLORS.TEXT_GRAY_MEDIUM} !important`)};
  }

  :disabled {
    opacity: 0.5;
  }
`;

export const ETASwitchButton = styled(Switch)`
  margin: 0;
  &.bp5-control.bp5-switch input:checked ~ .bp5-control-indicator {
    background-color: ${COLORS.GREEN_SUCCESS};
  }

  &.bp5-control.bp5-large {
    font-size: 22px;
    line-height: 1;
  }
`;

export const ETACheckbox = styled(Checkbox)`
  &.bp5-control input:checked ~ .bp5-control-indicator {
    background-color: ${COLORS.DARK_BLUE} !important;
  }
`;

export const ETAFooterContainer = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 64px;

  background: ${COLORS.WHITE};
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

export const CountSelectedText = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.BLUE_PALE};
  color: ${COLORS.BLUE_DARK};
  border-radius: 4px;

  font-size: 12px;
  line-height: 0;
`;

export const ETAEvaluationPrecedenceContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 16px;
`;

export const ETAEvaluationPrecedenceBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background: ${COLORS.BG_GRAY_LIGHT};
  padding: 16px;
  gap: 16px;
  overflow: hidden;
`;

export const ETAEvaluationList = styled.div`
  width: 100%;
  flex: 1;
  overflow: auto;
`;

// ETAEvaluationItem styled components
export const ETAEvaluationItemContainer = styled.div`
  margin-bottom: 8px;
  box-shadow: 0px 1px 2px 0px ${COLORS.SHADOW_BLACK};
  border-radius: 12px;
`;

export const ETAEvaluationColorTag = styled.div`
  display: inline-flex;
  width: 7px;
  height: 39px;
  background-color: ${COLORS.BLUE_LIGHT};
  border-radius: 2px;
`;

export const ETAEvaluationCollapseContainer = styled.div<{isExpanded?: boolean}>`
  background-color: ${COLORS.WHITE};
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: ${(props) => (props.isExpanded ? "12px 12px 0 0" : "12px")};
`;

export const ETAEvaluationHeaderItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 16px;
  min-width: 0;
  overflow: hidden;

  &:first-of-type {
    flex-shrink: 1;
  }

  &:last-of-type {
    flex-shrink: 0;
  }
`;

export const ETAEvaluationText = styled.span`
  color: ${COLORS.TEXT_GRAY};
  font-size: 16px;
`;

export const ETAEvaluationNameHeaderText = styled(Text)`
  color: ${COLORS.TEXT_BLACK};
  font-weight: 400;
  font-size: 16px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ETAEvaluationCollapseButton = styled.div`
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  cursor: pointer;
`;

export const ETAEvaluationDivider = styled.div`
  width: calc(100% - 20px);
  height: 1px;
  background-color: ${COLORS.COLOR_BORDER_LIGHT};
  margin: 0 auto;
  background: ${COLORS.WHITE};
  padding: 0 10px;

  &::after {
    content: "";
    display: block;
    height: 1px;
    background-color: ${COLORS.COLOR_BORDER_LIGHT};
  }
`;

export const ETAEvaluationContentContainer = styled.div`
  background-color: ${COLORS.WHITE};
  padding: 16px;
  width: 100%;
  border-radius: 0 0 12px 12px;
`;

export const ETAEvaluationContentSection = styled.div<{gap?: string; flexDirection?: string}>`
  margin-bottom: 12px;
  display: flex;
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "row")};
  gap: ${(props) => (props.gap ? props.gap : "8px")};
  align-items: flex-start;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ETAEvaluationContentRow = styled.div<{isInline?: boolean}>`
  display: ${(props) => (props.isInline ? "flex" : "block")};
  flex-wrap: ${(props) => (props.isInline ? "wrap" : "nowrap")};
  gap: ${(props) => (props.isInline ? "8px" : "0")};
  align-items: ${(props) => (props.isInline ? "baseline" : "flex-start")};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PremiumBadge = styled.span`
  display: inline-block;
  padding: 6px 14px;
  font-family: "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  line-height: 1;
  color: #1a2b4b;
  cursor: pointer;
  border-radius: 50px;
  border: 1px solid transparent;
  background: linear-gradient(113.52deg, rgba(240, 247, 255, 0.9) 23.38%, rgba(255, 245, 253, 0.9) 80.15%) padding-box,
    linear-gradient(115.96deg, #93c5fd 12.99%, #de8edf 75.53%) border-box;
  transition: all 0.3s ease;
  box-shadow: 0 0 5px rgba(157, 196, 255, 0.5), 0 0 5px rgba(226, 169, 229, 0.5);

  &:hover {
    box-shadow: 0 0 15px rgba(157, 196, 255, 0.5), 0 0 15px rgba(226, 169, 229, 0.5);
  }
`;

// DP-3098 — ETA notification feedback timeline ("Notification sent" pinned far left; clock markers
// positioned to-scale by minute offset — see buildNotificationTimeline).
export const TimelineContainer = styled.div<{isDisabled?: boolean}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 20px;
  background-color: ${COLORS.BG_GRAY_LIGHT};
  border-radius: 8px;
  ${(props) => (props.isDisabled ? "opacity: 0.45; pointer-events: none;" : "")}
`;

export const TimelineCaption = styled.p`
  margin: 0;
  font-style: italic;
  font-size: 14px;
  text-align: center;
  color: ${COLORS.TEXT_GRAY_MEDIUM};
`;

export const TimelineTrack = styled.div<{trackHeight: number}>`
  position: relative;
  height: ${(props) => props.trackHeight}px;
  margin: 0 16px;
`;

// Rail is anchored near the top (24px) so stacked role labels have room to grow downward.
export const TimelineRail = styled.div`
  position: absolute;
  top: 24px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: ${COLORS.BLUE_100};
  border-radius: 2px;
`;

export const TimelineBand = styled.div<{from: number; to: number; color: string}>`
  position: absolute;
  top: 0;
  height: 100%;
  left: ${(props) => props.from}%;
  width: ${(props) => Math.max(0, props.to - props.from)}%;
  background-color: ${(props) => props.color};
  border-radius: 2px;
`;

// DP-3116 — `outlined` draws a black ring around the (blue/red) dot when the ETA "Notification sent"
// time coincides with a clock marker. The inner white ring keeps a gap between fill and outline.
export const TimelineDot = styled.div<{left: number; color: string; outlined?: boolean}>`
  position: absolute;
  top: 24px;
  left: ${(props) => props.left}%;
  width: 12px;
  height: 12px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: ${(props) => props.color};
  box-shadow: ${(props) =>
    props.outlined ? `0 0 0 1px ${COLORS.WHITE}, 0 0 0 3px ${COLORS.GRAY_800}` : `0 0 0 1px ${COLORS.WHITE}`};
`;

export const TimelineValueLabel = styled.div<{left: number}>`
  position: absolute;
  left: ${(props) => props.left}%;
  top: 2px;
  transform: translateX(-50%);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  color: ${COLORS.TEXT_BLACK};
`;

// Stacked role labels grow downward from just below the rail (24px rail + 12px gap = 36px).
export const TimelineRoleLabel = styled.div<{left: number}>`
  position: absolute;
  left: ${(props) => props.left}%;
  top: 36px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  color: ${COLORS.TEXT_GRAY_MEDIUM};
`;
